const addUserCancelledErrorToRedirectURL = (redirectURLString, oAuthStateParameter, clientID) => {
  const redirectURL = new URL(redirectURLString)

  if (oAuthStateParameter) {
    redirectURL.searchParams.append('state', oAuthStateParameter)
  }

  redirectURL.searchParams.append('error', 'user_cancelled')

  if (clientID === 'ANOVA_GOOGLE_HOME') {
    const redirectURLWithHashParams = convertURLSearchParamsToHashParams(redirectURL)
    redirectURLWithHashParams.searchParams.delete('state')
    redirectURLWithHashParams.searchParams.delete('error')
    return redirectURLWithHashParams.href
  }

  return redirectURL.href
}

const convertURLSearchParamsToHashParams = (redirectURL) => {
  redirectURL.hash = redirectURL.searchParams.toString()

  return redirectURL
}

export default addUserCancelledErrorToRedirectURL
